import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import ListLayout from '../../../../component/listLayout'
import AddButton from '../../../../component/AddButton'
import InputSearch from '../../../../component/InputSearch'
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material'
import dayjs from 'dayjs'
import { getBranchList, getStockTransferList } from '../../services/api'
import { useSelector } from 'react-redux'

export default function StockTransferList() {
    const [data, setData] = useState([])
    const { profile } = useSelector(state => state.profile)
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let FromBranchNo = searchParams.get('FromBranchNo') || 'all'
    let ToBranchNo = searchParams.get('ToBranchNo') || 'all'
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    const [branchs, setBranchs] = useState([])

    const [fromBranchNo, setFromBranchNo] = useState('all');
    const [toBranchNo, setToBranchNo] = useState('all');
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);
    const [rowsPerPage] = useState(10);
    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getStockTransferList(q, FromBranchNo === 'all' ? '' : FromBranchNo, ToBranchNo  === 'all' ? '' : ToBranchNo, page, rowsPerPage)
            setData(data)
            setLoading(false)
        }
        getList()
    }, [q, FromBranchNo, ToBranchNo, page, rowsPerPage])

    // useEffect(() => {
    //     setFromBranchNo(FromBranchNo)
    //     setText(q)
    //     setToBranchNo(ToBranchNo)
    // }, [FromBranchNo, ToBranchNo, q])
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        getBranch()
    }, [])
    const head = [
        '',
        'ที่',
        'วันที่เอกสาร',
        'เลขที่เอกสาร',
        'จ่ายออก',
        'รับเข้า',
        'ปริมาณ (ตัน)',
        'ผู้ทำรายการ',
        'สถานะ',
        'ดำเนินการ',
    ]
    const body = data?.items?.map((x, i) => {

        return {
            id: x?.TransferNo,
            item1: x?.ReadStatus === 'N' && (profile?.BranchNo?.BranchNo === x?.ToBranchNo?.BranchNo) && <span> NEW!</span>,
            item2: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
            item3: dayjs(x?.DocumentDate).format('DD/MM/BBBB'),
            item4: x?.TransferNo,
            item5: x?.FromBranchNo?.BranchName,
            item6: x?.ToBranchNo?.BranchName,
            item7: x?.TotalQty?.toLocaleString(),
            item8: x?.ModifiedId,
            item9: x?.Status === 'D' ?
                <span class="status-draft">
                    บันทึกร่าง
                </span> : x?.Status === 'W' ?
                    <span class="status-wait">
                        รออนุมัติ
                    </span> : x?.Status === 'Y' ?
                        <span class="status-active">
                            เสร็จสิ้น
                        </span> : x?.Status === 'N' ?
                            <span class="status-inactive">
                                ยกเลิก
                            </span> : '',

            item10: [<Link to={`/stock/stock-transfer/${x?.TransferNo}`} onClick={() => setSearchParams({ id: x?.TransferNo, page: page, q: q })}>
                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
            </Link>]
            ,
        }
    })
    return (
        <ListLayout title={'รายการโอนเมล็ดพันธุ์ระหว่างศูนย์'} action={<>
            <AddButton link={'/stock/stock-transfer/add'} />
          
            <Box className={`backgroundField`} style={{ marginRight: "20px", width:"150px" }}>
                <FormControl variant="standard" fullWidth>
                    <Select value={fromBranchNo} onChange={e => setFromBranchNo(e.target.value)} disableUnderline
                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}

                    >
                        <MenuItem value={'all'}>{'จ่ายออกทั้งหมด'}</MenuItem>
                        {branchs?.map((x, i) => (
                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <Box className={`backgroundField`} style={{ marginRight: "20px", width:"150px" }}>
                <FormControl variant="standard" fullWidth>
                    <Select value={toBranchNo} onChange={e => setToBranchNo(e.target.value)}  disableUnderline
                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                    >
                        <MenuItem value={'all'}>{'รับเข้าทั้งหมด'}</MenuItem>
                        {branchs?.map((x, i) => (
                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <InputSearch value={text} onChange={e => setText(e.target.value)} placeholder={"ค้นหา เลขที่เอกสาร"} />
            <Box className="col-lg-2 col-md-12 text-center">
                <Button onClick={() => setSearchParams({ q: text, FromBranchNo: fromBranchNo, ToBranchNo: toBranchNo })} className="ButtomSearch" variant='contained'>ค้นหา</Button>
            </Box >
        </>} loading={loading} head={head} body={body} pagination={{
            count: data?.meta?.totalPages,
            page: +page,
            event: { q: q, id: id }
        }} id={id} setSearchParams={setSearchParams} />
    )
}
